import { render, staticRenderFns } from "./CommunityFinances.vue?vue&type=template&id=bec3ad92&scoped=true&"
import script from "./CommunityFinances.vue?vue&type=script&lang=js&"
export * from "./CommunityFinances.vue?vue&type=script&lang=js&"
import style0 from "./CommunityFinances.vue?vue&type=style&index=0&id=bec3ad92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec3ad92",
  null
  
)

export default component.exports